import styled from "styled-components";

export const StyledContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	h2 {
		font-family: 'Suit medium', 'Inter medium';
		font-size: 20px;
		font-weight: 800;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
		margin-bottom: 10px;
	}
	h3 {
		font-family: 'Suit regular';
		font-size: 16px;
		font-weight: 400;
		line-height: 22px;
		color: rgba(38, 38, 38, 1);
	}
`

export const StylledIcon = styled.div`
	width: 135px;
	height: 135px;
	border-radius: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	svg{
		width: 100%;
	}
`